import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import winkCommentApi from "api/winkCommentApi";

export const getWinkComments = createAsyncThunk(
  "WinkComment",
  async (params: any = {}) => {
    try {
      const response = await winkCommentApi.getComments(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getCommentList = async (params: any = {}) => {
  try {
    const response = await winkCommentApi.getComments(params);
    return response;
  } catch (error) {
    return error;
  }
};

export const getCommentDetail = async (
  id: string | number,
  params: any = {}
) => {
  try {
    const response = await winkCommentApi.getCommentDetail(id, params);
    return response;
  } catch (error) {
    return error;
  }
};

export const postComment = async (data: any = {}) => {
  try {
    const response = await winkCommentApi.postComment(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putComment = async (id: string | number, data: any = {}) => {
  try {
    const response = await winkCommentApi.putComment(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
